<template>
  <div class="artists-container">
    <div v-for="(artist, key) in artistItem" :key="'artist' + key" class="artist-item">
      <div class="image-wrapper">
        <img class="artist-image" :src="artist.image" alt="artist image" />
      </div>
      <div class="artist-info">
        <div class="artist-name">{{ artist.name }}</div>
        <div class="artist-link">
          <a :href="artist.link" target="_blank">{{ artist.link }}</a>
        </div>
        <p class="artist-description">{{ $t('artist.' + artist.description) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import djMasta from './djMasta.jpeg';
import abatcha from './abatcha.jpeg';
import bdc from './bdc.jpeg';

export default {
  data() {
    return {
      artistItem: [
        {
          name: 'DJ Masta',
          link: 'https://mastapremier.com/',
          image: djMasta,
          description: 'dj',
        },
        {
          name: 'Saïdou Abatcha',
          link: 'https://www.facebook.com/SaidouAbatchaOFFICIEL',
          image: abatcha,
          description: 'abatcha',
        },
        {
          name: 'BDC',
          link: 'https://www.facebook.com/BDCamer/',
          image: bdc,
          description: 'bdc',
        }
      ]
    };
  }
};
</script>

  
<style scoped>
@import './artist.css';

.artists-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.artist-item {
  width: 100%;
  border-bottom: 1px solid black;
  margin-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: url('../../../public/images/backgrounds/artistes.png') no-repeat center center;
  background-size: cover;
}

.image-wrapper {
  width: 40vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem;
}

.artist-image {
  width: 100%;
  border-radius: 20%;
  border: 1px solid black;
}

.artist-info {
  flex: 1;
  padding-left: 1rem;
}

.artist-name {
  font-weight: bold;
  font-size: 1.5rem;
  color: white;
  margin-bottom: 1rem;
}

.artist-link a {
  color: blue;
  text-decoration: underline;
  font-size: 1rem;
  display: inline-block;
  margin-bottom: 1rem;
}

.artist-description {
  font-size: 1.2rem;
  color: white;
  white-space: pre-wrap;
  text-align: left;
}

@media (max-width: 800px) {
  .artist-item {
    flex-direction: column;
    align-items: center;
    padding: 1rem;
  }

  .image-wrapper {
    width: 80vw;
  }

  .artist-name {
    font-size: 1.2rem;
  }

  .artist-description {
    font-size: 1rem;
    margin: 1rem;
  }
}
</style>
e>
  